import api from '@api';
import translate from '@translate';
import { call, put, race, take, takeEvery } from 'redux-saga/effects';
import {
    getShopifyPaymentMethodsFetchFailure,
    getShopifyPaymentMethodsFetchSuccess,
    getShopifyShippingMethodsFetchFailure,
    getShopifyShippingMethodsFetchSuccess,
    getShoptetPaymentMethodsFetchFailure,
    getShoptetPaymentMethodsFetchSuccess,
    getShoptetShippingMethodsFetchFailure,
    getShoptetShippingMethodsFetchSuccess,
    getShoptetStatusesFetchFailure,
    getShoptetStatusesFetchSuccess,
    getWoocommercePaymentMethodsFetchFailure,
    getWoocommercePaymentMethodsFetchSuccess,
    getWoocommerceShippingMethodsFetchFailure,
    getWoocommerceShippingMethodsFetchSuccess,
    saveSkladonMappingFetchFailure,
    saveSkladonMappingFetchStart,
    saveSkladonMappingFetchSuccess
} from './reducer';
import {
    ShopifyShippingMethod,
    ShoptetPaymentMethod,
    ShoptetShippingMethod,
    ShoptetStatus,
    WooCommercePaymentMethod,
    WooCommerceShippingMethod
} from 'skladon-types';
import { getSkladonMappingListFetch } from '../skladonMappingList/reducer';
import { ProviderType } from '../../types/provider';

const getShoptetStatusesDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/shoptet/${idProvider}/statuses`);
    return res.data.data;
};

function* getShoptetStatusesDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: ShoptetStatus[] = yield call((): unknown =>
            getShoptetStatusesDetailFetchRequest(action.payload)
        );
        yield put(getShoptetStatusesFetchSuccess(response));
    } catch (error) {
        yield put(getShoptetStatusesFetchFailure({ error }));
    }
}

export function* getShoptetStatusesDetailFetchWatch() {
    yield takeEvery('integrationDetail/getShoptetStatusesFetch', getShoptetStatusesDetailFetch);
}

const getShoptetShippingMethodsDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/shoptet/${idProvider}/shipping-methods`);
    return res.data.data;
};

function* getShoptetShippingMethodsDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: ShoptetShippingMethod[] = yield call((): unknown =>
            getShoptetShippingMethodsDetailFetchRequest(action.payload)
        );
        yield put(getShoptetShippingMethodsFetchSuccess(response));
    } catch (error) {
        yield put(getShoptetShippingMethodsFetchFailure({ error }));
    }
}

export function* getShoptetShippingMethodsDetailFetchWatch() {
    yield takeEvery('integrationDetail/getShoptetShippingMethodsFetch', getShoptetShippingMethodsDetailFetch);
}

const getShoptetPaymentMethodsDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/shoptet/${idProvider}/payment-methods`);
    return res.data.data;
};

function* getShoptetPaymentMethodsDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: ShoptetPaymentMethod[] = yield call((): unknown =>
            getShoptetPaymentMethodsDetailFetchRequest(action.payload)
        );
        yield put(getShoptetPaymentMethodsFetchSuccess(response));
    } catch (error) {
        yield put(getShoptetPaymentMethodsFetchFailure({ error }));
    }
}

export function* getShoptetPaymentMethodsDetailFetchWatch() {
    yield takeEvery('integrationDetail/getShoptetPaymentMethodsFetch', getShoptetPaymentMethodsDetailFetch);
}

const getShopifyShippingMethodsDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/shopify/${idProvider}/shipping-methods`);
    return res.data.data;
};

function* getShopifyShippingMethodsDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: ShopifyShippingMethod[] = yield call((): unknown =>
            getShopifyShippingMethodsDetailFetchRequest(action.payload)
        );
        yield put(getShopifyShippingMethodsFetchSuccess(response));
    } catch (error) {
        yield put(getShopifyShippingMethodsFetchFailure({ error }));
    }
}

export function* getShopifyShippingMethodsDetailFetchWatch() {
    yield takeEvery('integrationDetail/getShopifyShippingMethodsFetch', getShopifyShippingMethodsDetailFetch);
}

const getWoocommerceShippingMethodsDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/woocommerce/${idProvider}/shipping-methods`);
    return res.data.data;
};

function* getWoocommerceShippingMethodsDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: WooCommerceShippingMethod[] = yield call((): unknown =>
            getWoocommerceShippingMethodsDetailFetchRequest(action.payload)
        );
        yield put(getWoocommerceShippingMethodsFetchSuccess(response));
    } catch (error) {
        yield put(getWoocommerceShippingMethodsFetchFailure({ error }));
    }
}

export function* getWoocommerceShippingMethodsDetailFetchWatch() {
    yield takeEvery('integrationDetail/getWoocommerceShippingMethodsFetch', getWoocommerceShippingMethodsDetailFetch);
}

const getWoocommercePaymentMethodsDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/woocommerce/${idProvider}/payment-methods`);
    return res.data.data;
};

function* getWoocommercePaymentMethodsDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: WooCommercePaymentMethod[] = yield call((): unknown =>
            getWoocommercePaymentMethodsDetailFetchRequest(action.payload)
        );
        yield put(getWoocommercePaymentMethodsFetchSuccess(response));
    } catch (error) {
        yield put(getWoocommercePaymentMethodsFetchFailure({ error }));
    }
}

export function* getWoocommercePaymentMethodsDetailFetchWatch() {
    yield takeEvery('integrationDetail/getWoocommercePaymentMethodsFetch', getWoocommercePaymentMethodsDetailFetch);
}

const getShopifyPaymentMethodsDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/integration/shopify/${idProvider}/payment-methods`);
    return res.data.data;
};

function* getShopifyPaymentMethodsDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: string[] = yield call((): unknown => getShopifyPaymentMethodsDetailFetchRequest(action.payload));
        yield put(getShopifyPaymentMethodsFetchSuccess(response));
    } catch (error) {
        yield put(getShopifyPaymentMethodsFetchFailure({ error }));
    }
}

export function* getShopifyPaymentMethodsDetailFetchWatch() {
    yield takeEvery('integrationDetail/getShopifyPaymentMethodsFetch', getShopifyPaymentMethodsDetailFetch);
}

export type IntegrationMappingSaveSection = 'statuses' | 'shippingMethods' | 'paymentMethods' | 'others';

export interface SkladonMappingSavePayload {
    section: IntegrationMappingSaveSection;
    provider: Pick<ProviderType, 'ID' | 'SYSTEM' | 'ESHOP_KEY'>;
    statusesData?: unknown;
    shippingMethodsData?: unknown;
    paymentMethodsData?: unknown;
    othersData?: unknown;
    retinoData?: unknown;
    orderTypeIdsToDelete?: number[];
    retinoIdsToDelete?: number[];
}

const postIntegrationMappingBatchRequest = async (providerId: number, body: Record<string, unknown>) => {
    const res = await api('post', `api/secure/providers/${providerId}/integration-mapping/save`, body);
    return res.data;
};

function* saveSkladonMappingSaga(action: { type: string; payload: SkladonMappingSavePayload }): Generator {
    yield put(saveSkladonMappingFetchStart());
    try {
        const { provider, section, ...rest } = action.payload;
        const body: Record<string, unknown> = { section, ...rest };
        const providerId = provider.ID;
        if (providerId === undefined || providerId === null) {
            yield put(saveSkladonMappingFetchFailure());
            return;
        }

        yield call(() => postIntegrationMappingBatchRequest(providerId, body));

        yield put(getSkladonMappingListFetch(providerId));

        const raceResult = (yield race({
            success: take('skladonMappingList/getSkladonMappingListFetchSuccess'),
            failure: take('skladonMappingList/getSkladonMappingListFetchFailure')
        })) as { success?: unknown; failure?: unknown };

        if (raceResult.failure) {
            yield put(saveSkladonMappingFetchFailure());
            return;
        }

        yield put(
            saveSkladonMappingFetchSuccess({
                messageSuccess: { title: translate('integrationDetail.saveSuccess') }
            })
        );
    } catch (error) {
        console.error('Error in saveSkladonMappingSaga:', error);
        yield put(saveSkladonMappingFetchFailure());
    }
}

export function* saveSkladonMappingWatch() {
    yield takeEvery('integrationDetail/saveSkladonMappingFetch', saveSkladonMappingSaga);
}
